import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { PartnerService } from '../../partner-service';
import { Partner, PartnerUserDataGroup } from '../../models/partner';
import { PartnerUser, Privilege } from '../../models';
import { Person } from '../../models/Person';
import { PersonService } from '../../../person/person.service';
import { PartnerUserService } from '../../partner-user.service';
import { PrivilegeService } from '../../privilege.service';

@Component({
  selector: 'app-add-partner-user',
  templateUrl: './add-partner-user.component.html',
  styleUrls: ['./add-partner-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddPartnerUserComponent implements OnInit, OnDestroy {
  partnerUser: PartnerUser;
  uniqueKey: string;
  subscription: Subscription;
  relationshipExists = false;
  processing = false;
  person: Person;
  partnerUserDataGroup: PartnerUserDataGroup;
  selectedItemsNow: any[] = [];
  partnershipPrivileges: Privilege[] = [];

  @Input() displayAddDialogInput: boolean;
  @Input() partnerDetails: Partner;
  @Output() onDialogOpen = new EventEmitter<boolean>();
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onNewPartnerUser = new EventEmitter<any>();
  @Output() onError = new EventEmitter<string>();

  constructor(private partnerSvc: PartnerService, private personSvc: PersonService, private partnerUserSvc: PartnerUserService
    , private partnershipPrivilegeSvc: PrivilegeService) { }

  ngOnInit() {
    this.partnerUser = new PartnerUser();
    this.person = new Person();
    this.subscription = new Subscription();
    this.partnerUser.IsActive = true;
    this.person.IsActive = true;
    this.partnerUser.CanAddUser = false;
    // retrieving unique partnership privileges based on groups privileges and privileges.
    this.partnershipPrivileges = this.partnerSvc.getUniquePrivileges(this.partnerDetails.PrivilegeGroups,
      this.partnerDetails.Privileges);
      this.partnershipPrivileges = this.partnershipPrivilegeSvc.findByStatus(this.partnershipPrivileges, true);
  }

  dialogClose(): void {
    this.onDialogClose.emit(false);
  }

  dialogOpen(): void {
    this.onDialogOpen.emit(true);
  }

  // getting the latest selected items from privilege dropdown
  privilegeChange(privilege): void {
    this.selectedItemsNow = privilege.Privileges;
   }

  onSubmit(AddPartnerUserForm: NgForm): void {
    if (AddPartnerUserForm.valid) {
      this.partnerUser.Person = this.person;
      this.partnerUser.Privileges = this.selectedItemsNow;
      this.processing = true;
      this.partnerUserDataGroup = { PartnerUser: this.partnerUser, RelationshipDataGroup: null };
      this.subscription = this.partnerUserSvc.update(this.partnerDetails.RelationshipXrefId, this.partnerUserDataGroup)
        .subscribe((personData) => {
            this.onNewPartnerUser.emit(personData);
            this.processing = false;
            this.dialogClose();
        }, error => {
          this.onError.emit('Error Occcured while Processing');
          this.processing = false;
          this.dialogClose();
        });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
